export default __webpack_public_path__ + "static/media/reports-13.e99858ca.png";